export function Room(roomNumber,roomType) {
    this.Number = roomNumber;
    this.roomType = roomType;
  }